import { render, staticRenderFns } from "./AcknowledgmentsDialog.vue?vue&type=template&id=53ebfc6c"
import script from "./AcknowledgmentsDialog.vue?vue&type=script&lang=js"
export * from "./AcknowledgmentsDialog.vue?vue&type=script&lang=js"
import style0 from "./AcknowledgmentsDialog.vue?vue&type=style&index=0&id=53ebfc6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports